<div class="bl-chat-shell" [ngClass]="'bl-chat-shell--' + variant"
  [class.has-history]="canShowHistory && historyOpen">

  <!-- ── Historial de conversaciones ────────────────────────────────── -->
  <!-- Solo en pantalla completa: en el panel acoplado no hay ancho para
       una segunda columna -->
  <app-chat-history *ngIf="canShowHistory && historyOpen"
    [chats]="history" [activeId]="activeChatId" [loading]="historyLoading" [busy]="isBusy"
    (openChat)="openChat($event.id)" (newChat)="newChat()" (renameChat)="renameChat($event)"
    (deleteChat)="deleteChat($event)" (closePanel)="toggleHistory()"></app-chat-history>

<section class="bl-chat" [ngClass]="'bl-chat--' + variant">

  <!-- ── Cabecera ───────────────────────────────────────────────────── -->
  <header class="bl-chat-head">

    <div class="bl-chat-identity">
      <span class="bl-chat-identity-avatar">
        <img [src]="bixAvatar" alt="Bryant" />
        <span class="bl-chat-identity-dot" aria-hidden="true"></span>
      </span>
      <span class="bl-chat-identity-text">
        <span class="bl-chat-identity-name">Bryant</span>
        <span class="bl-chat-identity-status">
          <ng-container *ngIf="isBusy; else statusOnline">
            {{ label('Bryant está respondiendo…', 'Bryant is responding…') }}
          </ng-container>
          <ng-template #statusOnline>
            {{ label('Asistente de B.R.A.I.N. · en línea', 'B.R.A.I.N. assistant · online') }}
          </ng-template>
        </span>
      </span>
    </div>

    <div class="bl-chat-head-actions">

      <!-- Mostrar el panel de conversaciones cuando está plegado -->
      <button type="button" class="bl-icon-btn" *ngIf="canShowHistory && !historyOpen" (click)="toggleHistory()"
        [ngbTooltip]="label('Ver mis conversaciones', 'View my conversations')" container="body" placement="bottom">
        <i data-feather="message-square" size="17"></i>
      </button>

      <!-- Cuánto de la pantalla ocupa el panel. Solo tiene sentido acoplado -->
      <div class="bl-chat-widths" *ngIf="isDock">
        <button type="button" class="bl-chat-width-chip" *ngFor="let preset of widthPresets"
          [class.is-active]="dockWidth === preset" (click)="setDockWidth(preset)"
          [ngbTooltip]="label('El chat ocupa el ' + preset + '% de la pantalla', 'Chat takes ' + preset + '% of the screen')"
          container="body" placement="bottom">{{ preset }}%</button>
      </div>

      <!-- Empezar una conversación nueva sin perder la actual -->
      <button type="button" class="bl-icon-btn" (click)="newChat()" [disabled]="isBusy || messages.length === 0"
        [ngbTooltip]="label('Nuevo chat', 'New chat')" container="body" placement="bottom">
        <i data-feather="edit" size="17"></i>
      </button>

      <!-- Limpiar conversación -->
      <!-- <button type="button" class="bl-icon-btn" (click)="clearChat()" [disabled]="isBusy"
        [ngbTooltip]="('COMMON.BUTTONS.CLEAN' | translate) + ' chat'" container="body" placement="bottom">
        <i data-feather="trash-2" size="17"></i>
      </button> -->

      <!-- Expandir a página completa -->
      <button type="button" class="bl-icon-btn" *ngIf="!isPage" (click)="expandToPage()"
        [ngbTooltip]="label('Expandir a pantalla completa', 'Expand to full screen')" container="body" placement="bottom">
        <i data-feather="maximize-2" size="17"></i>
      </button>

      <!-- Volver al panel acoplado -->
      <button type="button" class="bl-icon-btn" *ngIf="isPage" (click)="collapseToDock()"
        [ngbTooltip]="label('Volver al panel lateral', 'Back to the side panel')" container="body" placement="bottom">
        <i data-feather="minimize-2" size="17"></i>
      </button>

      <!-- Cerrar -->
      <button type="button" class="bl-icon-btn bl-icon-btn--close" *ngIf="!isPage" (click)="closeChat()"
        [ngbTooltip]="'COMMON.BUTTONS.CLOSE' | translate" container="body" placement="bottom">
        <i data-feather="x" size="18"></i>
      </button>
    </div>
  </header>

  <!-- ── Agente ─────────────────────────────────────────────────────── -->
  <!-- Solo en desarrollo, donde hay más de un despliegue de Bryant. Fuera del
       de por omisión la barra se tiñe, para que no se olvide en cuál se está -->
  <div class="bl-chat-agent" *ngIf="hasAgentChoice" [class.bl-chat-agent--alert]="isSecondaryAgent">
    <span class="bl-chat-agent-icon">
      <lucide-icon name="server" [size]="15"></lucide-icon>
    </span>
    <span class="bl-chat-agent-label">{{ 'BELIVPEDIA.MESSAGES.BIX_AGENT' | translate }}</span>

    <div class="bl-chat-agent-options" role="group" [attr.aria-label]="'BELIVPEDIA.MESSAGES.BIX_AGENT' | translate">
      <button type="button" class="bl-chat-agent-option" *ngFor="let option of agentOptions"
        [class.active]="option.key === currentAgent.key" [attr.aria-pressed]="option.key === currentAgent.key"
        [disabled]="isBusy" (click)="selectAgent(option)">{{ option.label }}</button>
    </div>

    <span class="bl-chat-agent-hint">{{ 'BELIVPEDIA.MESSAGES.BIX_AGENT_HINT' | translate }}</span>
  </div>

  <!-- ── Conversación ───────────────────────────────────────────────── -->
  <div class="bl-chat-scroll" id="userChats" #scrollMe [scrollTop]="scrolltop">
    <div class="bl-chat-thread">

      <!-- Saludo / estado inicial -->
      <div class="bl-chat-hero" *ngIf="messages.length === 0">
        <span class="bl-chat-hero-avatar">
          <img [src]="bixAvatar" alt="Bryant" />
        </span>
        <p class="bl-chat-hero-text" [innerHTML]="'BELIVPEDIA.MESSAGES.WELCOME_CHAT' | translate"></p>
      </div>

      <!-- Mensaje de bienvenida cuando ya hay conversación -->
      <div class="bl-msg bl-msg--bot" *ngIf="messages.length > 0">
        <span class="bl-msg-avatar">
          <img [src]="bixAvatar" alt="Bryant" />
        </span>
        <div class="bl-msg-body">
          <div class="bl-bubble">
            <p class="mb-0" [innerHTML]="'BELIVPEDIA.MESSAGES.WELCOME_CHAT' | translate"></p>
          </div>
        </div>
      </div>

      <!-- Mensajes -->
      <ng-container *ngFor="let item of messages; trackBy: trackByMessage">

        <!-- ── Solicitud de aprobación de una herramienta MCP ────────── -->
        <div class="bl-msg bl-msg--bot" *ngIf="item.role === 'approval'; else regularMessage">
          <span class="bl-msg-avatar">
            <img [src]="bixAvatar" alt="Bryant" />
          </span>
          <div class="bl-msg-body">
            <div class="bl-approval">
              <span class="bl-approval-title">
                <i data-feather="shield" size="14"></i>
                {{ label('Bryant necesita tu permiso', 'Bryant needs your approval') }}
              </span>
              <p class="bl-approval-text">
                {{ label('Quiere usar la herramienta', 'It wants to run the tool') }}
                <strong>{{ item.mcpApproval?.toolName }}</strong>
                {{ label('de', 'from') }} <strong>{{ item.mcpApproval?.serverLabel }}</strong>.
              </p>
              <pre class="bl-approval-args" *ngIf="item.mcpApproval?.arguments">{{ item.mcpApproval.arguments }}</pre>
              <div class="bl-approval-actions" *ngIf="!item.approvalResolved">
                <button type="button" class="bl-approval-btn bl-approval-btn--yes" (click)="respondApproval(item, true)">
                  {{ label('Permitir', 'Allow') }}
                </button>
                <button type="button" class="bl-approval-btn" (click)="respondApproval(item, false)">
                  {{ label('Rechazar', 'Deny') }}
                </button>
              </div>
              <span class="bl-approval-done" *ngIf="item.approvalResolved">
                {{ label('Respuesta enviada', 'Answer sent') }}
              </span>
            </div>
          </div>
        </div>

        <!-- ── Mensaje normal ────────────────────────────────────────── -->
        <ng-template #regularMessage>
          <div class="bl-msg" *ngIf="!(item.role === 'assistant' && item.isStreaming && !item.content && !item.reasoning?.length)"
            [ngClass]="{
              'bl-msg--bot': item.role === 'assistant',
              'bl-msg--me': item.role === 'user'
            }">

            <!-- Avatar -->
            <span class="bl-msg-avatar">
              <img *ngIf="item.role === 'assistant'" [src]="bixAvatar" alt="Bryant" />
              <ng-container *ngIf="item.role === 'user' && currentUser">
                <img *ngIf="profilePhoto && profilePhoto.length > 0; else initialsAvatar" [src]="profilePhoto" alt="avatar" />
                <ng-template #initialsAvatar>
                  <span class="bl-msg-initials">{{ currentUser.person.name | slice:0:1 }}{{ currentUser.person.surname | slice:0:1 }}</span>
                </ng-template>
              </ng-container>
            </span>

            <div class="bl-msg-body">

              <!-- Razonamiento: mientras responde el encabezado es el paso en curso,
                   al terminar se convierte en el resumen de la respuesta -->
              <div class="bl-reasoning" *ngIf="item.reasoning?.length">
                <button type="button" class="bl-reasoning-toggle" (click)="toggleReasoning(item)"
                  [class.is-open]="item.reasoningOpen" [class.is-live]="item.isStreaming">
                  <span class="bl-reasoning-spark" [class.is-live]="item.isStreaming" aria-hidden="true"></span>

                  <span class="bl-live-step" *ngIf="item.isStreaming && liveStep(item) as step; else reasoningSummary">
                    <strong>{{ step.title }}</strong>
                  </span>
                  <ng-template #reasoningSummary>
                    {{ label('Cómo llegó a esta respuesta', 'How it got to this answer') }}
                  </ng-template>

                  <small class="bl-reasoning-count">({{ item.reasoning.length }})</small>
                  <i data-feather="chevron-down" size="14"></i>
                </button>

                <ol class="bl-reasoning-steps" *ngIf="item.reasoningOpen">
                  <li class="bl-reasoning-step" *ngFor="let step of item.reasoning"
                    [class.is-done]="step.done" [class.is-error]="step.error"
                    [class.is-live]="item.isStreaming && !step.done">
                    <span class="bl-reasoning-dot" aria-hidden="true"></span>
                    <span class="bl-reasoning-text">
                      <strong>{{ step.title }}</strong>
                    </span>
                  </li>
                </ol>
              </div>

              <div class="bl-bubble" *ngIf="item.display || item.attachments?.length || item.isStreaming">

                <!-- Adjuntos que el usuario mandó con el mensaje -->
                <div class="bl-bubble-attachments" *ngIf="item.attachments?.length">
                  <ng-container *ngFor="let attachment of item.attachments">
                    <img class="bl-bubble-image" *ngIf="attachment.dataUri && attachment.dataUri.startsWith('data:image/')"
                      [src]="attachment.dataUri" [alt]="attachment.fileName" />
                    <div class="bl-bubble-file" *ngIf="!attachment.dataUri || !attachment.dataUri.startsWith('data:image/')">
                      <i data-feather="file" size="14"></i>
                      <small class="text-truncate">{{ attachment.fileName }}</small>
                    </div>
                  </ng-container>
                </div>

                <markdown class="bl-md" *ngIf="item.display" [data]="item.display"
                  (click)="onMessageLinkClick($event)"></markdown>

                <!-- Todavía no llegó texto, pero el agente ya está trabajando -->
                <span class="bl-typing" *ngIf="item.isStreaming && !item.content" aria-live="polite"
                  [attr.aria-label]="label('Bryant está escribiendo', 'Bryant is typing')">
                  <i></i><i></i><i></i>
                </span>

                <!-- Cursor mientras el agente sigue escribiendo -->
                <span class="bl-caret" *ngIf="item.isStreaming && item.content" aria-hidden="true"></span>
              </div>

              <!-- Cuándo se envió o se recibió el mensaje -->
              <span class="bl-msg-time" *ngIf="item.more?.time && !item.isStreaming"
                [ngbTooltip]="messageTimeFull(item)" container="body" placement="top">
                {{ messageTime(item) }}
              </span>

              <!-- Adaptive Cards que devuelve el agente, con sus gráficos -->
              <app-chat-adaptive-card *ngFor="let chart of item.charts"
                [cardJson]="chart"></app-chat-adaptive-card>

              <!-- Fuentes citadas -->
              <div class="bl-sources" *ngIf="item.citations?.length">
                <span class="bl-sources-title">
                  <i data-feather="book-open" size="13"></i>
                  {{ label('Fuentes', 'Sources') }}
                </span>

                <div class="bl-source" *ngFor="let citation of item.citations">
                  <span class="bl-source-name text-break">
                    <span class="bl-source-index">{{ citation.index }}</span>
                    {{ citation.label | replace: '_' : ' ' }}
                  </span>
                  <div class="bl-source-actions">
                    <a class="bl-source-btn" *ngIf="citation.url" [href]="citation.url" target="_blank" rel="noopener">
                      <i data-feather="external-link" size="13"></i>
                      {{ label('Abrir enlace', 'Open link') }}
                    </a>
                    <button type="button" class="bl-source-btn" *ngIf="citation.fileId" (click)="showFile(citation.fileId)">
                      <i data-feather="external-link" size="13"></i>
                      {{ 'BELIVPEDIA.MESSAGES.OPEN_DOCUMENT' | translate }}
                    </button>
                    <button type="button" class="bl-source-btn" *ngIf="citation.quote" (click)="showQuote(citation.quote)">
                      <i data-feather="message-square" size="13"></i>
                      {{ 'BELIVPEDIA.MESSAGES.VIEW_QUOTE' | translate }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- Pie de la respuesta: aviso de IA, consumo y valoración -->
              <div class="bl-msg-foot" *ngIf="item.role === 'assistant' && !item.isStreaming && item.content">

                <span class="bl-msg-usage">
                  <i class="bl-msg-ai-icon" data-feather="zap" size="11"></i>
                  <span class="bl-msg-ai">{{ label('Contenido generado con IA', 'AI-generated content') }}</span>
                  <ng-container *ngIf="item.more?.usage">
                    · {{ item.more.usage.totalTokens | number }} tokens
                  </ng-container>
                  <ng-container *ngIf="item.duration">· {{ (item.duration / 1000) | number: '1.1-1' }}s</ng-container>
                </span>

                <div class="bl-msg-react">
                  <button type="button" class="bl-react-btn" (click)="copyMessage(item)"
                    [class.is-active]="copiedMessageId === item.id"
                    [ngbTooltip]="copiedMessageId === item.id ? label('Copiado', 'Copied') : label('Copiar la respuesta', 'Copy the answer')"
                    container="body" placement="top">
                    <i [data-feather]="copiedMessageId === item.id ? 'check' : 'copy'" [size]="14"></i>
                  </button>
                  <button type="button" class="bl-react-btn" (click)="like(item)" [disabled]="item.feedbackSent"
                    [class.is-active]="item.feedback === 'like'"
                    [ngbTooltip]="label('Me sirvió', 'Helpful')" container="body" placement="top">
                    <i data-feather="thumbs-up" size="14"></i>
                  </button>
                  <button type="button" class="bl-react-btn" (click)="dislike(item)" [disabled]="item.feedbackSent"
                    [class.is-active]="item.feedback === 'dislike'"
                    [ngbTooltip]="label('No me sirvió', 'Not helpful')" container="body" placement="top">
                    <i data-feather="thumbs-down" size="14"></i>
                  </button>
                  <small class="bl-react-thanks" *ngIf="item.feedbackSent">
                    {{ label('¡Gracias!', 'Thanks!') }}
                  </small>
                </div>
              </div>

              <!-- Comentario que acompaña al "no me sirvió" -->
              <div class="bl-feedback" *ngIf="item.feedbackOpen">
                <textarea class="bl-feedback-input" rows="2" [(ngModel)]="item.feedbackText"
                  [name]="'feedback-' + item.id"
                  [placeholder]="label('¿Qué le faltó a esta respuesta?', 'What was missing in this answer?')"></textarea>
                <div class="bl-feedback-actions">
                  <button type="button" class="bl-source-btn" (click)="cancelFeedback(item)">
                    {{ 'COMMON.BUTTONS.CANCEL' | translate }}
                  </button>
                  <button type="button" class="bl-source-btn bl-source-btn--primary" (click)="submitFeedback(item)">
                    {{ 'COMMON.BUTTONS.SEND' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>

      <!-- Escribiendo -->
      <div class="bl-msg bl-msg--bot" *ngIf="showTypingBubble">
        <span class="bl-msg-avatar">
          <img [src]="bixAvatar" alt="Bryant" />
        </span>
        <div class="bl-msg-body">
          <div class="bl-bubble bl-bubble--typing">
            <span class="bl-typing" aria-live="polite"
              [attr.aria-label]="label('Bryant está escribiendo', 'Bryant is typing')">
              <i></i><i></i><i></i>
            </span>
          </div>
        </div>
      </div>

      <!-- Error del turno -->
      <div class="bl-chat-error" *ngIf="error" role="alert">
        <i data-feather="alert-triangle" size="16"></i>
        <span class="bl-chat-error-text">{{ error.message }}</span>
        <div class="bl-chat-error-actions">
          <button type="button" class="bl-source-btn bl-source-btn--primary" *ngIf="error.action" (click)="retry()">
            {{ error.action.label }}
          </button>
          <button type="button" class="bl-source-btn" (click)="dismissError()">
            {{ 'COMMON.BUTTONS.CLOSE' | translate }}
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- ── Compositor ─────────────────────────────────────────────────── -->
  <footer class="bl-chat-composer">

    <!-- Adjuntos pendientes de enviar -->
    <div class="bl-attach-list" *ngIf="pendingFiles.length > 0">
      <div class="bl-attach-preview" *ngFor="let file of pendingFiles; let i = index">
        <img *ngIf="file.mimeType.startsWith('image/'); else fileGlyph" [src]="file.dataUri" [alt]="file.name" />
        <ng-template #fileGlyph>
          <i [data-feather]="fileIcon(file.mimeType)" [size]="16"></i>
        </ng-template>
        <span class="bl-attach-name text-truncate" [title]="file.name">{{ file.name }}</span>
        <small class="bl-attach-size">{{ fileSize(file.sizeBytes) }}</small>
        <button type="button" class="bl-attach-remove" (click)="removePendingFile(i)"
          [ngbTooltip]="'BELIVPEDIA.MESSAGES.BIX_REMOVE_IMAGE' | translate" container="body">
          <i data-feather="x" size="14"></i>
        </button>
      </div>
    </div>

    <div class="bl-composer-box">

      <!-- Adjuntar -->
      <label class="bl-composer-attach" [attr.for]="'attach-doc-' + variant"
        [ngbTooltip]="label('Adjuntar archivos', 'Attach files')" container="body" placement="top">
        <i data-feather="paperclip" size="18"></i>
        <input type="file" [id]="'attach-doc-' + variant" hidden multiple [disabled]="isBusy"
          (change)="onFilesSelected($event)"
          accept=".png,.jpg,.jpeg,.gif,.webp,.pdf,.txt,.md,.csv,.json,.html,.xml,.docx,.xlsx,.pptx" />
      </label>

      <!-- Capturar la pantalla y adjuntarla -->
      <button type="button" class="bl-composer-attach" (click)="attachScreenshot()" [disabled]="isBusy"
        [ngbTooltip]="label('Adjuntar una captura de la pantalla', 'Attach a screenshot')"
        container="body" placement="top">
        <i [data-feather]="'monitor'" [size]="18"></i>
      </button>

      <textarea class="bl-composer-input" rows="1" #composer
        [placeholder]="'COMMON.PLACEHOLDER.MESSAGE' | translate"
        [(ngModel)]="draft" name="chat-message" [disabled]="isBusy"
        (keydown)="onComposerKeydown($event)" (input)="autoGrow(composer)"></textarea>

      <!-- Detener la respuesta en curso -->
      <button type="button" class="bl-composer-send bl-composer-send--stop" *ngIf="isBusy" (click)="stopStreaming()"
        [ngbTooltip]="label('Detener la respuesta', 'Stop the response')" container="body" placement="top">
        <i data-feather="square" size="16"></i>
      </button>

      <!-- Enviar -->
      <button type="button" class="bl-composer-send" *ngIf="!isBusy" [disabled]="!canSend"
        (click)="submitDraft(); autoGrow(composer)"
        [ngbTooltip]="canSend ? ('COMMON.BUTTONS.SEND' | translate) : ('BELIVPEDIA.MESSAGES.MESSAGE_EMPTY' | translate)"
        container="body" placement="top">
        <i data-feather="send" size="18"></i>
      </button>
    </div>

    <span class="bl-composer-hint">
      {{ label('Enter para enviar · Shift + Enter para salto de línea', 'Enter to send · Shift + Enter for a new line') }}
    </span>
  </footer>
</section>
</div>
